export enum ScriptLanguage {
  JavaScript = "javascript",
  Python = "python",
}
